import React from "react";
import "./HairSalonNearMeCustomer.css";
const HairSalonNearMeCustomer = () => {
  return (
    <div className="hairSalonNearMeCustomer">
      <h5>What Clients Say About SCENT: The Hair Salon Near Me You’ll Love?</h5>
      <p>
        Don’t just take our word for it! Here’s what some of our satisfied
        clients have to say about their experiences at SCENT:
      </p>
      <div className="hairSalonNearMeCustomerContent">
        <p>
          <span className="quote">“</span>I was searching for a reliable hair
          salon near me and came across SCENT. From the moment I walked in, I
          knew I was in good hands. The stylist listened to exactly what I
          wanted, and the results were even better than I imagined!
          <span className="quote">”</span> - <span>Riya</span>
        </p>
        <p>
          <span className="quote">“</span>SCENT is by far the best hair salon
          near me. The environment is so relaxing, and the stylists really know
          their stuff. I always leave feeling like a new person
          <span className="quote">”</span> - <span>Ananya </span>
        </p>
        <p>
          <span className="quote">“</span>I got a keratin treatment at SCENT,
          and my hair has never looked so smooth. If you’re looking for a
          top-notch hair salon near me, SCENT is the one
          <span className="quote">”</span> - <span> Priya</span>
        </p>
      </div>
    </div>
  );
};

export default HairSalonNearMeCustomer;
